import { Grid, Divider } from '@mui/material';
import React, { useState, useMemo } from 'react';
import { CompanyStatus } from '../../../../types/company';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import { DeleteIcon } from '../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../util/color.util';
import MultiSelectionList from '../../common/MultiSelectionList';
import SearchBar from '../../common/SearchBar';
import { FilterProps } from '../common/filter.util';
import { CompanyStatusFilter } from './CompanyStatusFilter';

interface CompanyStatusFilterContentProps {
  filter: CompanyStatusFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
  color?: string;
}

export default function CompanyStatusFilterContent({
  filter,
  filterProps,
  setFilterProps,
  color,
}: CompanyStatusFilterContentProps) {
  const [textFilter, setTextFilter] = useState<string>('');

  const values = useMemo(() => {
    return new Set([...Object.values(CompanyStatus)].filter(status => filter.search(status, textFilter)));
  }, [textFilter, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.companyStatus = selected;
    if (!filterProps.companyStatus?.size) filterProps.companyStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.companyStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-ventory-grey-500 text-[13px] font-[500]'>
              {translate({ key: TranslationKey.companyStatus })}
            </p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setTextFilter(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          color={color}
          selected={filterProps.companyStatus}
          values={values}
          onChange={handleChange}
          toText={status => translate({ key: status as any })}
        />
      </Grid>
    </Grid>
  );
}
